export const routes = [
  {
    id: "cemedi",
    name: "CEMEDI",
    path: "/cemedi",
    icon: "assets/icons/dashboard.svg",
    required: true,
    applications: ["cemedi"],
  },
  {
    id: "dashboard-root",
    name: "Dashboard",
    path: "/",
    icon: "assets/icons/dashboard.svg",
    required: true,
    applications: ["tgone", "cemedi"],
  },
  {
    id: "home",
    name: "Inicio",
    path: "/home",
    icon: "assets/icons/connect.svg",
    required: true,
    applications: ["tgone", "cemedi"],
  },
  {
    id: "locations",
    name: "Locaciones",
    path: "/locations",
    icon: "assets/icons/ubicacion.svg",
    applications: ["tgone", "cemedi"],
  },
  { id: "sections", name: "Areas", path: "/sections", icon: "assets/icons/objetivo.svg", applications: ["tgone", "cemedi"] },
  {
    id: "industrial-assets",
    name: "Activos industriales",
    path: "/industrial-assets",
    icon: "assets/icons/motor.svg",
    applications: ["tgone", "cemedi"],
  },
  { id: "devices", name: "Dispositivos", path: "/devices", icon: "assets/icons/conexion.svg", applications: ["tgone", "cemedi"] },
  { id: "links", name: "Vinculaciones", path: "/links", icon: "assets/icons/iteration.svg", applications: ["tgone", "cemedi"] },
  { id: "users", name: "Usuarios", path: "/users", icon: "assets/icons/avatar.svg", applications: ["tgone", "cemedi"] },
  {
    id: "work-groups",
    name: "Equipos de trabajo",
    path: "/work-groups",
    icon: "assets/icons/group.svg",
    applications: ["tgone", "cemedi"],
  },
  { id: "support", name: "Soporte", path: "/video-call", icon: "assets/icons/engineer.svg", applications: ["tgone", "cemedi"] },
  {
    id: "calendar",
    name: "Calendario",
    path: "/calendar",
    icon: "assets/icons/calendario.svg",
    applications: ["tgone", "cemedi"],
  },
  {
    id: "catalogs",
    name: "Catalogos",
    path: "/catalogs",
    icon: "assets/icons/overlay.svg",
    allowRoles: ["663536e2-bdb4-4887-a313-c42d3e00bc37"],
    applications: ["tgone", "cemedi"],
  },
  {
    id: "config",
    name: "Configuracion",
    path: "/config",
    icon: "assets/icons/settings.svg",
    required: true,
    applications: ["tgone", "cemedi"],
  },
  {
    id: "viewer",
    name: "Dashboard",
    path: "/viewer",
    icon: "assets/icons/panel.svg",
    hidden: true,
    applications: ["tgone", "cemedi"],
  },
];

export const selectableToolRoutes = routes.filter((route) => !route.hidden && !route.required);
export const defaultToolIds = selectableToolRoutes.map((route) => route.id);
export const requiredVisibleRoutes = routes.filter((route) => route.required && !route.hidden);

export const applicationOptions = [
  {
    id: "tgone",
    name: "TGOne",
    description: "Dashboard de favoritos",
    path: "/",
    image: "assets/images/tgone-logo.png",
  },
  {
    id: "cemedi",
    name: "CEMEDI",
    description: "EntityMap",
    path: "/cemedi",
    image: "assets/images/logo192.png",
  },
];

export const getInitialDashboardPath = (application) =>
  application === "cemedi" ? "/cemedi" : "/";

export const getUserPreferenceId = (user) =>
  user?.id || user?.id_usuario || user?.email || user?.vc_email || user?.vc_correo;
